import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { safeAuthRedirect } from '../utils/authRedirect';
import { getApiBase } from '../utils/api';

export default function SAMLCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    // Old callback parameters never establish identity. Confirm the cookie
    // session with the backend, then navigate to an application-local path.
    window.history.replaceState({}, document.title, window.location.pathname);
    fetch(`${getApiBase()}/auth/me`, { credentials: 'include', cache: 'no-store' })
      .then(async response => {
        if (!response.ok) throw new Error('Sign-in failed. Please start again.');
        const data = await response.json();
        if (!data.user) throw new Error('Sign-in failed. Please start again.');
        if (!active) return;
        setUser(data.user);
        const redirect = safeAuthRedirect(sessionStorage.getItem('authReturnUrl'));
        sessionStorage.removeItem('authReturnUrl');
        navigate(redirect, { replace: true });
      }).catch(error => { if (active) setError(error.message); });
    return () => { active = false; };
  }, [navigate, setUser]);
  return <div className="p-8 text-center">{error ? <><p>{error}</p><a href="/login">Return to sign-in</a></> : <p>Completing your sign-in…</p>}</div>;
}
